import { render, staticRenderFns } from "./moreOUOE.vue?vue&type=template&id=31228ffb&lang=pug&"
import script from "./moreOUOE.vue?vue&type=script&lang=js&"
export * from "./moreOUOE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports